import { Link } from '../router';
import Icon from './Icon';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">
        <p className="eyebrow">Have something in mind?</p>
        <a href="mailto:hello@kingshuk.dev" className="footer-email">hello@kingshuk.dev <Icon name="arrowUp" /></a>
      </div>
      <div className="footer-bottom">
        <Link className="wordmark wordmark--footer" to="/"><span>K</span>Kingshuk.</Link>
        <p>Independent developer · Available worldwide</p>
        <div className="socials"><a href="https://www.linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a><a href="https://github.com" target="_blank" rel="noreferrer">GitHub</a><a href="mailto:hello@kingshuk.dev">Email</a></div>
        <p>© {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
}
